/* eslint-disable object-shorthand */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';

export type HistoryState = {
  historyService: any;
};

export const defaultState: HistoryState = {
  historyService: null,
};

export type State = {
  historyService: any;
};

export const historyStateContext = React.createContext<State | null>(null);

const Provider = ({
  children,
  historyService,
}: {
  children: React.ReactNode;
  historyService?: any;
}) => {
  const [state] = React.useState({
    ...defaultState,
    historyService: historyService,
  });

  return <historyStateContext.Provider value={state}>{children}</historyStateContext.Provider>;
};

function useHistoryState() {
  const context = React.useContext(historyStateContext);
  if (!context) {
    throw new Error('useHistoryState must be used within a Provider');
  }
  return context;
}

export default { Provider, useHistoryState };
